<template>
<div class="container" id="main">
  <router-link to="/properties/new" class="btn btn-primary">New Property</router-link>
<table class="table table-light">
  <thead class="thead-dark">
    <tr>
      <th scope="col">Title</th>
      <th scope="col">URL</th>
      <th scope="col">ID</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="row in rows" :key="row._id">
      <td><router-link :to="'/properties/edit/' + row._id">{{row.title}}</router-link></td>
      <td>{{row.url}}</td>
      <td>{{row._id}}</td>
    </tr>
  </tbody>
</table>
<div class="progress" style="margin: 20px 0;" v-show="pagination">
  <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
</div>
</div>
</template>
<script>
import {api} from '../api.js';
import ui from '../ui.js';
export default {
  name: 'Properties',
  data: function() {
    return {
      rows: [],
      pagination: false,
      fetching: false,
      page: 1,
      total: 0
    }
  },
  mounted: function() {
    window.addEventListener('scroll', this.onScroll);
    this.fetch();
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll: function() {
      if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
        if (this.pagination && !this.fetching) {
          this.fetching = true;
          this.paginate();
        }
      }
    },
    paginate: function() {
      this.page++;
      this.fetch();
    },
    fetch: function() {
      api.get('/properties', {
        params: {
          limit: 12,
          page: this.page
        }
      }).then((response) => {
        response.data.docs.forEach((doc) => {
          this.rows.push(doc);
        });
        this.pagination = response.data.page < response.data.pages;
        this.fetching = false;
      }).catch((error) => {
        ui.alert(error.response.data);
        this.fetching = false;
      });
    }
  }
}
</script>
